export default __webpack_public_path__ + "static/header-logo-cio-731088b6637fcd6b8921fe0d54d1bc35.png";